"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function labelGroup(data) {
    return new LabelGroup(data);
}
exports.labelGroup = labelGroup;
var LabelGroup = /** @class */ (function () {
    function LabelGroup(data) {
        this._maxWidth = 600;
        this._minWidth = 0;
        this._minGap = 14;
        this.data = data;
    }
    LabelGroup.prototype.minGap = function (gap) {
        this._minGap = gap;
        return this;
    };
    LabelGroup.prototype.maxSize = function (size) {
        this._minWidth = size[0];
        this._maxWidth = size[1];
        return this;
    };
    LabelGroup.prototype.displayX = function (fn) {
        this._displayX = fn;
        return this;
    };
    LabelGroup.prototype.prepare = function () {
        // initialize distance obj, reset all related fields in data
        this._distance = [0];
        var di;
        var pi; // data[i], previous i
        for (var i = 0; i < this.data.length; i++) {
            di = this.data[i];
            pi = this.data[i - 1];
            di._adjustedX = di._displayX = this._displayX(di);
            di._offsetX = 0;
            di._displayed = di._displayX >= 0 && di._displayX <= this._maxWidth;
            if (i === 0) {
                continue;
            }
            this._distance[i] = di._displayX - pi._displayX;
        }
        // initialize groups
        this._groups = [];
        this._groupOf = Array.from(Array(this.data.length));
    };
    LabelGroup.prototype.adjust = function (group) {
        var minPos = this.data[group.min]._displayX;
        var maxPos = this.data[group.max]._displayX;
        var mutCount = group.max - group.min + 1;
        var spanNeeded = (mutCount - 1) * this._minGap;
        var spanMidPoint = (minPos + maxPos) / 2;
        var leftEdge = spanMidPoint - spanNeeded / 2;
        var rightEdge = spanMidPoint + spanNeeded / 2;
        // check if need to add left element to group
        if (group.min > 0) { // if not the first mut point
            var prev = group.min - 1;
            var leftElX = this.data[prev]._displayX;
            if (leftElX >= 0 && leftEdge - leftElX < this._minGap) {
                // add left element to group
                if (this._groupOf[prev]) { // if left already belongs to a group, need merge
                    var leftGroup = this._groupOf[prev];
                    // remove left group
                    var leftGroupIndex = this._groups.indexOf(leftGroup);
                    console.assert(leftGroupIndex >= 0);
                    this._groups.splice(leftGroupIndex, 1);
                    // merge
                    group.min = leftGroup.min;
                    for (var i = leftGroup.min; i <= leftGroup.max; i++) {
                        this._groupOf[i] = group;
                    }
                }
                else { // don't need merge
                    group.min = prev;
                    this._groupOf[prev] = group;
                }
                this.adjust(group);
            }
        }
        // check if need to add left element to group
        if (group.max < this.data.length - 1) {
            var next = group.max + 1;
            var rightElX = this.data[next]._displayX;
            if (rightElX <= this._maxWidth && rightElX - rightEdge < this._minGap) {
                // add right
                if (this._groupOf[next]) { // next has a group, need merge
                    var rightGroup = this._groupOf[next];
                    // remove right group
                    var rightGroupIndex = this._groups.indexOf(rightGroup);
                    console.assert(rightGroupIndex >= 0);
                    this._groups.splice(rightGroupIndex, 1);
                    // merge
                    group.max = rightGroup.max;
                    for (var i = rightGroup.min; i <= rightGroup.max; i++) {
                        this._groupOf[i] = group;
                    }
                }
                else {
                    group.max = next;
                    this._groupOf[next] = group;
                }
                this.adjust(group);
            }
        }
    };
    LabelGroup.prototype.run = function () {
        this.prepare();
        // do grouping
        for (var i = 1; i < this._distance.length; i++) {
            var curr = this._distance[i];
            if (curr < this._minGap && !this._groupOf[i] && this.data[i]._displayX <= this._maxWidth) {
                // group two close elements
                var group = { min: i - 1, max: i };
                this._groups.push(group);
                this._groupOf[i] = this._groupOf[i - 1] = group;
                this.adjust(group);
            }
        }
        // calculate
        for (var _i = 0, _a = this._groups; _i < _a.length; _i++) {
            var i = _a[_i];
            var minPos = this.data[i.min]._displayX;
            var maxPos = this.data[i.max]._displayX;
            var count = i.max - i.min + 1;
            var spanNeeded = (count - 1) * this._minGap;
            var spanMidPoint = (minPos + maxPos) / 2;
            var leftEdge = spanMidPoint - spanNeeded / 2;
            var j = -1;
            for (var k = i.min; k <= i.max; k++) {
                j++;
                this.data[k]._adjustedX = leftEdge + this._minGap * j;
                this.data[k]._offsetX = this.data[k]._adjustedX - this.data[k]._displayX;
            }
        }
        return this.data;
    };
    return LabelGroup;
}());
exports.LabelGroup = LabelGroup;
//# sourceMappingURL=label-group.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/algo/label-group.js
// module id = 878
// module chunks = 0 1